import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
app-static-toast .p-component.p-toast {
	border: 0;
	background: transparent;
	box-shadow: none;
	padding: 0;
}

@media (min-width: 64rem) {
	app-static-toast:not(.static-toast-fluid) .p-component.p-toast {
		min-width: 37.5rem;
	}
}

app-static-toast.static-toast-fluid .p-component.p-toast {
	width: 100%;
	max-width: 100%;
}

app-static-toast.static-toast-fluid .p-toast-message {
	width: 100%;
	margin: 0;
}

app-static-toast.static-toast-fluid .p-toast-message-content {
	align-items: flex-start;
	width: 100%;
	min-width: 0;
}

app-static-toast.static-toast-fluid .p-toast-message-text {
	flex: 1 1 auto;
	min-width: 0;
}

app-static-toast.static-toast-fluid .p-toast-summary,
app-static-toast.static-toast-fluid .p-toast-detail {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: normal;
	overflow-wrap: anywhere;
}

app-static-toast .static-toast-icon-wrap {
	display: flex;
	align-items: center;
	padding-block: 0.25rem;
	flex-shrink: 0;
}

app-static-toast .static-toast-icon {
	font-size: ${dt('toast.icon.size')};
	line-height: 1;
	color: ${dt('toast.colorScheme.light.root.info.color')};
}

app-static-toast .static-toast-close {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: ${dt('toast.closeButton.width')};
	height: ${dt('toast.closeButton.height')};
	border: 0;
	border-radius: ${dt('toast.closeButton.borderRadius')};
	background: transparent;
	color: ${dt('toast.colorScheme.light.root.info.color')};
	cursor: pointer;
	padding: 0;
}

app-static-toast .static-toast-close:hover {
	background: ${dt('toast.colorScheme.light.root.info.close.button.hover.background')};
}

app-static-toast .static-toast-close .pi {
	font-size: 0.875rem;
	line-height: 1;
}
`;
